export function isDataProtocol() {
  var _window;
  return typeof window !== 'undefined' && ((_window = window) == null || (_window = _window.location) == null ? void 0 : _window.protocol) === 'data:';
}
export const getCookieOverrideValue = artifactId => {
  if (typeof document === 'undefined') {
    return null;
  }
  if (isDataProtocol()) {
    return null;
  }
  const wixStaticsVersionsCookie = document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith('wixStaticsVersions='));
  if (!wixStaticsVersionsCookie) {
    return null;
  }
  const cookieValue = wixStaticsVersionsCookie.split('=')[1].trim();
  const overrideArtifactEntry = cookieValue.split('|').find(overrideEntry => overrideEntry.startsWith(`${artifactId}#`));
  if (!overrideArtifactEntry) {
    return null;
  }
  return overrideArtifactEntry.split('#')[1];
};
//# sourceMappingURL=cookie-utils.js.map